import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fdc3f38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resetPassword" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "重置密码", -1))
const _hoisted_3 = { class: "row row2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "请设置6-20位字母，数字的两种组合 ", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("完成并登录")

import { ref, reactive, watch, getCurrentInstance } from 'vue'
import { TResponse } from "@/module/common"
import { getResetPwd, getVerCode } from "@/api/login";
import { ElMessage } from 'element-plus'
import type { FormInstance } from 'element-plus'
import md5 from "js-md5";


export default /*#__PURE__*/_defineComponent({
  __name: 'resetPassword',
  props: {
    isShow: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props


let isShowDialog = ref(props.isShow)
watch(() => props.isShow, (newVal) => {
    isShowDialog.value = newVal
});

const ruleFormRef = ref<FormInstance>()
const ruleForm = reactive({
    phone: '',// 电话
    verificationCode: '',// 验证码
    newPwd: '',//新密码
    checkPass: '',//确认新密码
    wait: 60 // 倒计时
})

// 表单格式验证
// 手机号验证
const validatePhone = (rule: any, value: any, callback: any) => {
  let str=new RegExp("^1[3578]\\d{9}$");
  if(!str.test(value)){
    callback(new Error('手机号错误！'))
  }else{
    callback()
  }
}
// 新密码验证
const validatePass = (rule: any, value: any, callback: any) => {
    if (value === '') {
        callback(new Error('密码不能为空！'))
    } else {
        if (ruleForm.checkPass !== '') {
            if (!ruleFormRef.value) return
            ruleFormRef.value.validateField('checkPass', () => null)
        }
    }
    var str = RegExp("^[0-9a-zA-Z]*$")
    if(!str.test(value)||value.length<6||value.length>20){
        callback(new Error('当前密码格式不正确!'))
    }else{
        callback()
    }
}
// 确认密码验证
const validatePass2 = (rule: any, value: any, callback: any) => {
  if (value === '') {
    callback(new Error('密码不能为空！'));
  } else if (value !== ruleForm.newPwd) {
    callback(new Error('两次输入密码不一致!'));
  } else {
    callback()
  }
}
const rules = reactive({
  phone: [{ validator: validatePhone, trigger: 'blur' }],
  newPwd: [{ validator: validatePass, trigger: 'blur' }],
  checkPass: [{ validator: validatePass2, trigger: 'blur' }],
})

// 获取发送验证码
let timer:any = null
let VerCode= ()=>{
    if (!timer) {
        if(ruleForm.phone!==''){
            GetVerCode()
            timer = setTimeout(() => {
                clearTimeout(timer)
                timer = null
            }, 60000)
        }else{
            ElMessage('请输入手机号再试！')
        }
    }
}
let GetVerCode= async()=>{
    let res:TResponse<string>=await getVerCode({Mobile: ruleForm.phone})
    let {Code,Data,Message}= res
    if(Code===200){
        Time()
    }else{
        ElMessage(Message)
    }
}
// 设置倒计时60s
let Time=()=>{
    var codeBtn = document.getElementsByClassName('getYzm')[0]
    if (ruleForm.wait===0) {
        codeBtn.innerHTML = "获取验证码"
        ruleForm.wait = 60
    }else{
        codeBtn.innerHTML = ruleForm.wait + "秒后重试"
        ruleForm.wait--
        setTimeout(function(){
            Time()
        },1000)
    }
}

// 重置密码
const ResetPwd = (formEl: FormInstance | undefined) => {
  if (!formEl) return
  formEl.validate((valid:any) => {
    if (valid) { // 提交成功
        GetResetPwd()
    } else {
      return false
    }
  })
}
// 提交接口
let GetResetPwd= async()=>{
    let res:TResponse<boolean>=await getResetPwd({Mobile: ruleForm.phone,SMSCode: ruleForm.verificationCode,Password: md5(ruleForm.checkPass).toUpperCase()})
    let {Code,Data,Message}= res
    if(Code===200){
        isShowDialog.value = false
        ElMessage('重置密码成功！')
    }else{
        ElMessage(Message)
    }
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: _unref(isShowDialog),
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(isShowDialog) ? (isShowDialog).value = $event : isShowDialog = $event)),
      "show-close": true,
      "close-on-press-escape": false,
      "close-on-click-modal": true
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: ruleForm,
          "status-icon": "",
          rules: rules,
          class: "demo-ruleForm"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "",
              prop: "phone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: ruleForm.phone,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.phone) = $event)),
                  placeholder: "请输入手机号码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                modelValue: ruleForm.verificationCode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.verificationCode) = $event)),
                placeholder: "请输入验证码"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", {
                class: "getYzm",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(VerCode)()))
              }, "获取验证码")
            ]),
            _createVNode(_component_el_form_item, {
              label: "",
              prop: "newPwd"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "password",
                  modelValue: ruleForm.newPwd,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ruleForm.newPwd) = $event)),
                  placeholder: "请输入6-20位新密码",
                  autocomplete: "off"
                }, null, 8, ["modelValue"]),
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "",
              prop: "checkPass"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "password",
                  modelValue: ruleForm.checkPass,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((ruleForm.checkPass) = $event)),
                  placeholder: "请再次输入密码",
                  autocomplete: "off"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  class: "loginBtn",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (ResetPwd(ruleFormRef.value)))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})